import React, { useState } from "react";
import { IoIosSend } from "react-icons/io";
import imageAtContact from "../../assets/imageAtContact.png";
import { api } from "../../utils/api";
import { useToast } from "../../components/shared/ToastProvider";
import { useTranslation } from "react-i18next";
import { API_ROUTES } from "../../routes/apiRoutes";
export default function ContactForm() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const { addToast } = useToast();
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await api.post(API_ROUTES.CONTACT_US, {
        ...formData,
        subject: "Need more details",
      });

      addToast("Message sent successfully", "success");
      setFormData({ name: "", email: "", message: "" });
    } catch (err) {
      addToast("Failed to send message", "error");
    } finally {
      setLoading(false);
    }
  };
  const { t } = useTranslation();
  return (
    <section className="max-w-6xl mx-auto grid md:grid-cols-2 md:gap-6 lg:gap-12 py-0 px-2 md:py-16 mt-9 ">
      {/* Left Image */}
      <div className="relative flex justify-center md:justify-start overflow-visible">
        {/* Green slab: only on large screens */}
        <div className="relative flex justify-center md:justify-start">
          {/* Green box only for lg and xl */}
          <div className="absolute top-[-45px] left-[-180px] -translate-x-4 h-[120%] w-48 bg-green-900 z-0 hidden xl:block" />

          {/* Image overlaps the green slab on lg+ via left offset */}
          <img
            src={imageAtContact}
            alt="Contact"
            className="hidden md:block
        relative z-10
        w-72 sm:w-96 md:w-full md:h-full object-cover rounded-sm
         xl:left-[-3.5rem]
      "
          />
        </div>
      </div>

      {/* Right Contact Form */}
      <div className="mt-8 md:mt-0">
        <h2 className="font-arya text-2xl sm:text-3xl font-semibold mb-8 text-center md:text-left">
          {t("contact.contactForm.title")}
        </h2>

        <form className="space-y-8" onSubmit={handleSubmit}>
          {/* Name */}
          <div>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder={t("contact.contactForm.namePlaceholder")}
              className="w-full border-b border-gray-300 bg-transparent focus:border-green-700 outline-none py-2 placeholder-gray-500"
              required
            />
          </div>

          {/* Email */}
          <div>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder={t("contact.contactForm.emailPlaceholder")}
              className="w-full border-b border-gray-300 bg-transparent focus:border-green-700 outline-none py-2 placeholder-gray-500"
              required
            />
          </div>

          {/* Message */}
          <div>
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              placeholder={t("contact.contactForm.messagePlaceholder")}
              rows="3"
              className="w-full border-b border-gray-300 bg-transparent focus:border-green-700 outline-none py-2 placeholder-gray-500"
            />
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-green-800 text-white py-3 flex items-center justify-center gap-2 font-medium tracking-wide disabled:opacity-50"
          >
            <IoIosSend className="h-4 w-4" />
            {loading
              ? t("contact.contactForm.sending")
              : t("contact.contactForm.send")}
          </button>
        </form>

        {/* Privacy Note */}
        <p className="text-sm text-gray-600 mt-6 leading-relaxed text-center md:text-left">
          {t("contact.contactForm.privacyNote")}
        </p>
      </div>
    </section>
  );
}
